// extracted by mini-css-extract-plugin
export var pageContent = "PrivacyPage-module--page-content--PSOG8";